import React from 'react';
import { Box } from '@material-ui/core';
import AffiliateManagement from '../../components/admin/affiliate/AffiliateManagement';

const AdminAffiliateManagement: React.FC = () => {
  return (
    <Box style={{ padding: 24 }}>
      <AffiliateManagement />
    </Box>
  );
};

export default AdminAffiliateManagement;
